import api from 'api'

type WorkerAssessmentQuestion = {
  id: number
  name: string
  idealAnswer: string
  evaluationCriteria: string
}

type WorkerAssessmentCallItem = {
  shiftId: number
  startedAt: string
  endedAt: string
  questions: WorkerAssessmentQuestion[]
  // The nullable fields should always be present in theory, but there's a chance they aren't
  aiSummary: string | null
  recordingUrl: string | null
  transcriptUrl: string | null
}

type WorkerAssessmentRequirement = {
  id: number
  name: string
  questions: WorkerAssessmentQuestion[]
}

type WorkerAssessmentPositionStatus =
  | 'new'
  | 'in_progress'
  | 'incomplete'
  | 'pending_approval'
  | 'conditionally_approved'
  | 'approved'

type WorkerAssessmentDetail = {
  workerId: number
  workerName: string
  positionId: number
  positionName: string
  status: WorkerAssessmentPositionStatus | null
  assessmentCalls: WorkerAssessmentCallItem[]
  requirements: WorkerAssessmentRequirement[]
}

export const getWorkerAssessment = async ({
  positionId,
  userId,
}: {
  positionId: number
  userId: number
}): Promise<WorkerAssessmentDetail> => {
  const result = await api.get<WorkerAssessmentDetail>(
    `/admin/positions/${positionId}/assessments/user/${userId}`
  )
  return result.data
}
